import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex w-full" }
const _hoisted_2 = { class: "px-2 md:px-14 flex flex-col justify-start w-full" }
const _hoisted_3 = { class: "flex justify-between items-center md:items-start" }
const _hoisted_4 = { class: "flex flex-col md:flex-row my-4 w-full mt-6 space-y-8 md:space-y-0 md:space-x-4" }
const _hoisted_5 = { class: "lg:w-9/12" }
const _hoisted_6 = { class: "mb-2" }
const _hoisted_7 = { class: "lg:w-3/12" }
const _hoisted_8 = { class: "mb-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Errors = _resolveComponent("Errors")!
  const _component_Calendar = _resolveComponent("Calendar")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("form", {
        onSubmit: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.saveProfile()), ["prevent"])),
        class: "bg-white p-5 md:p-8 rounded-md shadow-md"
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h6", null, _toDisplayString(_ctx.$t("labels.generic", {
                pt: "Informações pessoais",
                en: "Personal Info",
              })), 1),
          _createVNode(_component_Button, {
            type: "submit",
            label: "Salvar",
            class: "btn-primary p-button-sm",
            loading: _ctx.loading
          }, null, 8, ["loading"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, [
            _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t("labels.generic", { pt: "Nome Completo", en: "Name" })), 1),
            _createVNode(_component_InputText, {
              id: "name",
              type: "text",
              modelValue: _ctx.user.name,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.user.name) = $event))
            }, null, 8, ["modelValue"]),
            _createVNode(_component_Errors, {
              errors: _ctx.v$.user.name.$errors
            }, null, 8, ["errors"])
          ]),
          _createElementVNode("span", _hoisted_7, [
            _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.$t("labels.generic", {
                  pt: "Data de Nascimento",
                  en: "Birthdate",
                })), 1),
            _createVNode(_component_Calendar, {
              modelValue: _ctx.user.birthDate,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.user.birthDate) = $event)),
              class: "w-full",
              dateFormat: "dd/mm/yy",
              manualInput: false
            }, null, 8, ["modelValue"]),
            _createVNode(_component_Errors, {
              errors: _ctx.v$.user.birthDate.$errors
            }, null, 8, ["errors"])
          ])
        ])
      ], 32)
    ])
  ]))
}